import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { fadeInAndUp } from '../../../constants/keyframes/movement';

const StyledWrapper = styled.div`
	animation: ${fadeInAndUp} 400ms ease;
`;

interface Props {}

const ResultsLoader: FC<Props> = () => {
	return (
		<StyledWrapper>
			<ContentLoader height={447} width={1083} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
				<circle cx="72" cy="81" r="50" />
				<circle cx="999" cy="81" r="50" />
				<circle cx="814" cy="81" r="50" />
				<circle cx="629" cy="81" r="50" />
				<circle cx="444" cy="81" r="50" />
				<circle cx="256" cy="81" r="50" />
				<rect x="135" y="79" rx="0" ry="0" width="43" height="5" />
				<rect x="325" y="79" rx="0" ry="0" width="43" height="5" />
				<rect x="515" y="79" rx="0" ry="0" width="43" height="5" />
				<rect x="705" y="79" rx="0" ry="0" width="43" height="5" />
				<rect x="885" y="79" rx="0" ry="0" width="43" height="5" />
				<rect x="23" y="153" rx="0" ry="0" width="106" height="15" />
				<rect x="185" y="151" rx="0" ry="0" width="136" height="15" />
				<rect x="390" y="150" rx="0" ry="0" width="108" height="15" />
				<rect x="571" y="152" rx="0" ry="0" width="120" height="15" />
				<rect x="750" y="152" rx="0" ry="0" width="120" height="15" />
				<rect x="950" y="150" rx="0" ry="0" width="100" height="15" />
				<rect x="10" y="246" rx="0" ry="0" width="1055" height="80" />
				<rect x="10" y="337" rx="0" ry="0" width="1055" height="80" />
			</ContentLoader>
		</StyledWrapper>
	);
};

export default ResultsLoader;
